import  {baseActions}  from "./base.actions";

export const certfileActions = {
    uploadbase64,
   
};

function uploadbase64(obj,func=null) {
    
    return baseActions.post(obj,'file','uploadbase64',null,func)
}
